import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { environment } from "../environments/environment"

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  //dataUrl = environment.zodaicDataProfiles; //works
  // dataUrl = 'http://echo.jsontest.com/key/value/one/two'; //tuts
  // dataUrl = environment.zodaicDataUrl; //trial
  //calendarUrl = environment.zodaicDataUrl;

  // profiles: Object[] = [];
  CalendarData: Object[] = [];

  constructor(private https: HttpClient) {
    //CALLS WHEN BEING CREATED
    // this.http.get('http://localhost:3003/test').subscribe( data => {
      
    //   // months = data.hasOwnProperty(months);
    //   // console.log("auto check return data", data.hasOwnProperty('month'));
      
    //   // this.profiles.push(data)
    //   // console.log('svc constructor-profiles check - ready: ', this.profiles);
    //   console.log('svc constructor-profiles check - ready: ');

      
    // }

    // )

    // this.http.get(this.dataUrl).toPromise().then(data => {
    //   console.log('auto call', data);
    //   // for ( let key in data)
    //   //   if(data.hasOwnProperty(key))
    //   //     this.profiles.push(this.data[key])
    // });

   }



  //MANUAL CALL
  getZodaicData() {


    // this.http.get('http://localhost:3000/test').toPromise().then(data => {
    //   console.log('auto call', data);
    //   // for ( let key in data)
    //   //   if(data.hasOwnProperty(key))
    //   //     this.profiles.push(this.data[key])
    // });

    // console.log('get zodiac data hit from service', this.dataUrl)

    // return this.http.get('http://bosweb_bos-api:3003/test') //working from th API
    // return this.http.get('http://localhost:3003/test') //working from th API
    // return this.http.get('http://localhost:3003/calendar/2021') //working from th API
    return this.https.get(environment.BOSAPI) //DO Apps
    // return this.http.get(this.dataUrl) //working internal version

    // return this.http.get('https://api.openbrewerydb.org/breweries')
  };

  // getCalendarData(){
  //   // console.log('svc-req-hit months data check', this.profiles)
  //   // return this.profiles
  // }


}
